var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMega(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 80,
    y: 160,
    id: "svg7394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "g7392",
    transform: "matrix(1.25,0,0,1.25,2,2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8,16 C 3.584,16 0,12.416 0,8 0,3.584 3.584,0 8,0 c 4.416,0 8,3.584 8,8 0,4.416 -3.584,8 -8,8 z",
    fill: "#d90007",
    id: "path7386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12,10.436 c 0,0.13 -0.105,0.23 -0.235,0.23 h -1.01 a 0.231,0.231 0 0 1 -0.235,-0.23 v -3.02 c 0,-0.028 -0.035,-0.038 -0.05,-0.023 l -2.135,2.08 a 0.478,0.478 0 0 1 -0.67,0 L 5.53,7.393 C 5.515,7.378 5.48,7.388 5.48,7.417 v 3.019 c 0,0.13 -0.105,0.23 -0.235,0.23 H 4.235 A 0.231,0.231 0 0 1 4,10.436 V 5.12 C 4,4.99 4.105,4.889 4.235,4.889 H 4.93 c 0.125,0 0.245,0.048 0.335,0.135 l 2.65,2.585 a 0.127,0.127 0 0 0 0.17,0 l 2.65,-2.585 A 0.483,0.483 0 0 1 11.07,4.889 h 0.695 C 11.895,4.889 12,4.99 12,5.12 v 5.316",
    fill: "#ffffff",
    id: "path7388"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMega);
export default __webpack_public_path__ + "static/media/Mega.7868d04d600a933f0c0516258b5d9e84.svg";
export { ForwardRef as ReactComponent };